import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

/**
 * "Back to list" that keeps the list's filters, tab and page.
 *
 * Hardcoding `navigate('/orders')` threw away the query string the user came from.
 * When there is an in-app history entry we pop it instead; deep links / refreshes
 * (no previous entry) still fall back to the plain list route.
 */
export function useBackToList(listPath: string): () => void {
  const navigate = useNavigate()
  const location = useLocation()
  const hasHistoryEntry = !!location.key && location.key !== 'default'

  return useCallback(() => {
    if (hasHistoryEntry) {
      void navigate(-1)
      return
    }
    void navigate(listPath)
  }, [navigate, hasHistoryEntry, listPath])
}
